import { loginRequest, graphConfig } from "../../msalConfig";
import {useMsal} from "@azure/msal-react";
import msalContext from '../api/msalAuth'
// const { instance} = useMsal();
export async function getAccessToken() {
    //TODO: figure out how to properly call
    const account = msalContext.getActiveAccount();
    if (!account) {
        throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    }

    const response = await msalContext.acquireTokenSilent({
        ...loginRequest,
        account: account
    });
    return response.accessToken;

    return  response.accessToken
    // return response.accessToken;
}
export async function callMsGraph(accessToken : String) {
    if (!accessToken) {
        accessToken = await getAccessToken();
    }

    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    return await fetch(graphConfig.graphMeEndpoint, options);
}